import cloneDeep from 'lodash/cloneDeep';
import {
  SET_ITEMS,
  SET_TOTAL,
  SET_CRITERE_RECHERCHE,
  SET_TOTAL_FACTURES_BEFORE_NOW,
  SET_DISPLAY_FACTURES_ANT,
  SET_DATES_FACTURES_SAVE,
  SET_CUMUL_BY_TYPE_ACTION_ACHAT,
  SET_LAST_PAYLOAD,
} from '@/store/modules/baux/paiementSurFacture-mutation-type';
import * as allTypes from '@/store/mutation-type';
import { getEcheanceAPayerAsync, getCumulEcheanceAPayer } from '@/api/mouvementClient';
import genererCritereRecherchePaiementSurFacture
  from '@/services/baux/echeancesAPayer/genererCritereRecherchePaiementSurFacture';
import transform from '@/services/mouvementClient/echeanceAPayerSurFactureServerTableDataTransformer';

function initialState() {
  return {
    items: [],
    total: 0,
    totalFacturesBeforeNow: 0,
    displayFacturesAnt: false,
    datesFacturesSave: {
      dateDebut: null,
      dateFin: new Date(),
    },
    critereRecherche: genererCritereRecherchePaiementSurFacture(),
    cumulByTypeActionAchat: null,
    lastPayload: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [SET_ITEMS](state, items) {
    state.items = items;
  },
  [SET_TOTAL](state, total) {
    state.total = total;
  },
  [SET_CRITERE_RECHERCHE](state, criteresRecherche) {
    state.critereRecherche = criteresRecherche;
  },
  [SET_TOTAL_FACTURES_BEFORE_NOW](state, total) {
    state.totalFacturesBeforeNow = total;
  },
  [SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [SET_DISPLAY_FACTURES_ANT](state, displayEcheancesAnt) {
    state.displayFacturesAnt = displayEcheancesAnt;
  },
  [SET_DATES_FACTURES_SAVE](state, datesEcheances) {
    state.datesFacturesSave = datesEcheances;
  },
  [SET_CUMUL_BY_TYPE_ACTION_ACHAT](state, cumulByTypeActionAchat) {
    state.cumulByTypeActionAchat = cumulByTypeActionAchat;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadFactureAPayer({ commit }, data) {
    commit(SET_TOTAL_FACTURES_BEFORE_NOW, -1);
    const result = await getEcheanceAPayerAsync(data);
    result.data.result.items.forEach((echeanceAPayer) => {
      echeanceAPayer.selected = false;
      echeanceAPayer.validateur = cloneDeep(echeanceAPayer.validateurs);
      delete echeanceAPayer.validateurs;
    });
    commit(SET_ITEMS, result.data.result.items);
    commit(SET_TOTAL, result.data.result.totalCount);
    commit(SET_LAST_PAYLOAD, cloneDeep(transform(data)));
    const newData = cloneDeep(data);
    newData.query.dates.dateDebut = null;
    newData.query.dates.dateFin = new Date();
    getEcheanceAPayerAsync(newData).then(result => {
      commit(SET_TOTAL_FACTURES_BEFORE_NOW, result.data.result.totalCount);
    });
    getCumulEcheanceAPayer(data).then(result => {
      commit(SET_CUMUL_BY_TYPE_ACTION_ACHAT, result.data.result);
    });
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  total: state => {
    return state.total;
  },
  critereRecherche: state => {
    return state.critereRecherche;
  },
  totalFacturesBeforeNow: state => {
    return state.totalFacturesBeforeNow;
  },
  displayFacturesAnt: state => {
    return state.displayFacturesAnt;
  },
  datesFacturesSave: state => {
    return state.datesFacturesSave;
  },
  cumulByTypeActionAchat: state => {
    return state.cumulByTypeActionAchat;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
